import { jsx as c } from "react/jsx-runtime";
import { memo as i, forwardRef as n } from "react";
import { Slot as l } from "../../node_modules/@radix-ui/react-slot/dist/index.es.js";
import T from "../../_virtual/index.es.js";
import "../stitches.config.es.js";
import { textStyles as d } from "./Text.styles.es.js";
import { textVariants as k } from "./Text.styles.es.js";
const t = n(function({
  children: r,
  as: m,
  asChild: e = !1,
  className: s,
  fontSize: p,
  fontWeight: o,
  variant: a,
  ...x
}, f) {
  return /* @__PURE__ */ c(e ? l : m || "span", { ref: f, className: T(d({
    variant: a,
    fontSize: p,
    ...o && {
      css: {
        fontWeight: o
      }
    }
  }), s), ...x, children: r });
}), R = i(t);
t.displayName = "Text";
const V = t;
export {
  V as BodyText,
  R as default,
  k as textVariants
};
//# sourceMappingURL=Text.es.js.map
